import { ReactElement } from "react";

export type NotificationType = "error" | "success" | "warning" | "info";

export const getNotificationIcon = (type: NotificationType): ReactElement => {
  const srcMap = {
    error: "/assets/svg/common/ErrorNotificationIcon.svg",
    success: "/assets/svg/common/SuccessNotificationIcon.svg",
    warning: "/assets/svg/common/WarningNotificationIcon.svg",
    info: "/assets/svg/common/InfoNotificationIcon.svg",
  };

  return (
    <img
      src={srcMap[type]}
      width={20}
      height={20}
      alt={type}
      style={{ pointerEvents: "none" }}
    />
  );
};
